import {EDIT_ERROR_SUCCESS} from "../../../reducers/editErrorReducer";


export const editErrorSuccess = (error) =>{
    return {
        type: EDIT_ERROR_SUCCESS,
        payload: {error}
    }
}